// extracted by mini-css-extract-plugin
module.exports = {"defaultColor":"#D1D5DB","types":"style_types__1wfyo","icon":"style_icon__29hr7"};